export const SCOPES_APOLLO_CLIENT_NAME = 'scope';
